import * as React from 'react';
import { UnstyledButton, UnstyledButtonProps } from '@mantine/core';
import { createLink, LinkComponent } from '@tanstack/react-router';

type MantineUnstyledButtonProps = Omit<UnstyledButtonProps, 'href'>;

const MantineLinkComponent = React.forwardRef<
  HTMLButtonElement,
  MantineUnstyledButtonProps
>((props, ref) => {
  return <UnstyledButton ref={ref} {...props} />;
});

MantineLinkComponent.displayName = 'MantineLinkComponent';

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const LinkButton: LinkComponent<typeof MantineLinkComponent> = (
  props
) => {
  return <CreatedLinkComponent {...props} />;
};
